import React from "react";
import { graphql } from "gatsby";

import SearchableList from "components/SearchableList";
import BlogPostThumbnail from "components/BlogPostThumbnail";
import BlogFeaturedPost from "components/BlogFeaturedPost";
import BlogTopPicks from "components/BlogTopPicks";

import * as styles from "../styles.module.less";

// Blogpost Fragments
export const FeaturedPostFragment = graphql`
  fragment FeaturedPost on MarkdownRemark {
    frontmatter {
      title
      date
      tags
      description
      thumbnail {
        image {
          thumbnailImage: childImageSharp {
            fluid(
              maxWidth: 570
              maxHeight: 420
              cropFocus: CENTER
              quality: 100
            ) {
              ...GatsbyImageSharpFluid
            }
          }
          extension
          publicURL
        }
        alt
        caption
      }
    }
    excerpt(pruneLength: 115)
    fields {
      path
    }
  }
`;

/**
 * @typedef {object} BlogTemplateProps
 * @prop {GatsbyTypes.BlogPostThumbnailFragment[]} blogPosts
 * @prop {readonly GatsbyTypes.BlogPostThumbnailFragment[]} topPicksPosts
 * @prop {GatsbyTypes.FeaturedPostFragment} featuredPost
 * @prop {readonly string[]} tags
 * @prop {object} searchIndex
 * @prop {string} featuredPostLinkButtonText
 * @prop {string} featuredPostLinkButtonIcon
 * @prop {string} topPicksPostsLabelText
 *
 * @param {BlogTemplateProps} props
 */

export function BlogTemplate({
  featuredPost,
  topPicksPosts,
  blogPosts,
  tags,
  searchIndex,
  featuredPostLinkButtonText,
  featuredPostLinkButtonIcon,
  topPicksPostsLabelText,
}) {
  return (
    <>
      {featuredPost && (
        <BlogFeaturedPost
          {...featuredPost.frontmatter}
          path={featuredPost.fields.path}
          excerpt={featuredPost.excerpt}
          linkButtonText={featuredPostLinkButtonText}
          linkButtonIcon={featuredPostLinkButtonIcon}
        />
      )}
      {topPicksPosts && (
        <BlogTopPicks
          labelText={topPicksPostsLabelText}
          posts={topPicksPosts || []}
        />
      )}
      <div className={styles.regularContainer}>
        <SearchableList
          searchConfig={{
            fields: {
              title: { boost: 2, bool: "AND" },
              body: {},
              description: {},
              subtitle: {},
            },
          }}
          dataSource={blogPosts}
          categories={{
            name: "Tags",
            search: (selectedCategory, node) =>
              node.frontmatter.tags.includes(selectedCategory),
            values: tags,
          }}
          pagination={{
            defaultPageSize: 16,
          }}
          grid={{
            gutter: 32,
            xs: 1,
            sm: 2,
            md: 3,
            lg: 4,
            xl: 4,
            xxl: 4,
          }}
          renderItem={(post, index) => (
            <BlogPostThumbnail key={`postthumbnail-${index}`} {...post} />
          )}
          index={searchIndex}
        />
      </div>
    </>
  );
}
